export default "__VITE_ASSET__TaFwNir___"